// @flow
import React, { PureComponent, type ComponentType } from "react";
import { connect, Dispatch } from "react-redux";
import { getDisplayName } from "data/constants";
import { setSettingAction } from "data/actions";
import * as s from "data/reducers/selectors";

type Config = {
    /** setting name in store */
    name: string,
    /** namespace for props */
    namespace: string,
    /** defaultValue to assign when not found in storage */
    defaultValue?: ?Object,
};

type Props = {
    /** Redux dispatch */
    dispatch: Dispatch,
};

export type SettingValueProps = {
    value: ?Object,
    setValue: (value: Object) => void,
};

/** will return the current setting's value and dispatch an action on change
 * @deprecated please use hooks/usePersistSetting
 */
const SettingValue =
    ({ name, namespace, defaultValue }: Config) =>
    (WrappedComponent: ComponentType<any>) => {
        class PP extends PureComponent<Props> {
            static displayName = `SettingValue(${getDisplayName(
                WrappedComponent
            )})`;

            _setValue = (value: Object) =>
                this.props.dispatch(setSettingAction(name, value));

            render() {
                const extraProps = {
                    [namespace]: {
                        value: this.props[namespace].value,
                        setValue: this._setValue,
                    },
                };

                return <WrappedComponent {...this.props} {...extraProps} />;
            }
        }

        const mapStateToProps = (state, ownProps) => {
            const currentValue = s.settingValueSelector(name, state);
            return {
                [namespace]: {
                    value:
                        /*istanbul ignore next */ currentValue == null
                            ? defaultValue
                            : currentValue,
                },
                ...ownProps,
            };
        };

        return connect(mapStateToProps)(PP);
    };

export default SettingValue;
